module.exports = __webpack_public_path__ + "static/media/engineirpd5.b7c6474c.svg";